<template>
    <div class="fourth_pc_page" id="fourth_pc_page">
        <!-- <div class="pc_loading" id="pc_page"> -->
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'最强蜗牛'"></div>
        <div class="title"></div>
        <div class="logo"></div>
        <div class="box">
            <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
            </div>
        </div>

    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
export default {
    name: 'fourth',
    data() {
        return {
        }
    },
    created() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }

        const reload = () => {
            const { protocol, host } = window.location;
            const link = `${protocol}//${host}/snail/fourth/pc${getRandomString()}`;
            setTimeout(() => {
                window.location.href = `${link}?referer=game`;
            }, 200);
        };

    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style lang="less">
@import url("./pc.less");
</style>


// WEBPACK FOOTER //
// src/pages/snail/fourth/pc/index.vue